import React from 'react';
import { aboutData } from '../data/mockData';

export const About = () => {
  return (
    <section id="about" className="py-20 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-4xl mx-auto">
          {/* Title */}
          <div className="text-center mb-12">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              {aboutData.title}
            </h2>
            <div className="w-20 h-1 bg-gradient-to-r from-[#eb068c] to-[#c7056f] mx-auto rounded-full"></div>
          </div>

          {/* Content */}
          <div className="bg-gradient-to-br from-pink-50 to-fuchsia-50 rounded-3xl p-8 md:p-12 border border-pink-100 shadow-xl">
            <div className="text-lg md:text-xl text-gray-700 leading-relaxed space-y-5">
              <p>A Plantinha de Geladeira é um <strong className="text-[#eb068c]">presente criativo, vivo e colecionável</strong>.</p>

              <p>100% brasileiro, com <strong>5 patentes</strong> e atendimento <strong>B2B e B2C</strong> em todo o território nacional.</p>

              <p>Criada em 2022, nasceu com o propósito de aproximar as pessoas da natureza de forma simples, afetiva e surpreendente, transformando pequenos momentos da rotina em experiências de conexão e bem-estar.</p>

              <p>Todas as nossas suculentas são cultivadas por produtores independentes, garantindo plantas saudáveis, bonitas e cuidadosamente selecionadas.</p>

              <p>Mais do que decorar, a Plantinha de Geladeira une <strong className="text-[#eb068c]">natureza, design e conexão emocional</strong> em uma lembrança que permanece presente por meses na rotina de quem a recebe.</p>

              <p>Produzida com responsabilidade, propósito e cuidado em cada detalhe, ela transforma pequenos gestos em experiências memoráveis.</p>

              <p className="text-xl md:text-2xl font-semibold text-gray-900 pt-2">
                Plantinha de Geladeira: criando conexões genuínas entre marcas e pessoas <span className="inline-block">🌱</span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
